import type { ReactNode } from "react";
import s from "../network.module.css";

export function PageFrame({ title, subtitle, actions, children }: { title: string; subtitle?: ReactNode; actions?: ReactNode; children: ReactNode }) {
  return (
    <div className={s.page}>
      <div className={s.pageHeader}>
        <div className="u-grow">
          <div className={s.pageTitle}>{title}</div>
          {subtitle && <div className={s.pageSub}>{subtitle}</div>}
        </div>
        {actions}
      </div>
      <div className={s.pageBody}>{children}</div>
    </div>
  );
}
